

































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import BudgetExpense from "@/models/porposal/budgetExpense.model";
@Component
export default class BudgetExpenseEdit extends GenericEdit<BudgetExpense> {
  constructor() {
    super();
    this.controller = 'BudgetExpense';
    this.model = new BudgetExpense();
  }
}
